import { Base_Url } from "../../BaseURL/BaseUrl";
import {
  getApiWithAuthorization,
  postApiWithAuthorization,
} from "../ApiMethods/ApiMethod";

const UserRoleUrl = `${Base_Url}/Country`;

export const GetCountryList = async (params) => {
  const res = await postApiWithAuthorization(
    `${UserRoleUrl}/GetCountryList`,
    params
  );
  return res;
};

export const AddUpdateCountry = async (params) => {
  const res = await postApiWithAuthorization(
    `${UserRoleUrl}/AddUpdateCountry?ModuleName=${params.ModuleName}`,
    params
  );
  return res;
};
export const GetCountryModel = async (ModuleName, KeyID, AdminKeyID) => {
  const res = await getApiWithAuthorization(
    `${UserRoleUrl}/GetCountryModel?ModuleName=${ModuleName}&AdminKeyID=${AdminKeyID}&CountryKeyID=${KeyID}`
  );
  return res;
};

export const ChangeCountryStatus = async (KeyID, AdminKeyID) => {
  const res = await getApiWithAuthorization(
    `${UserRoleUrl}/ChangeCountryStatus?AdminKeyID=${AdminKeyID}&CountryKeyID=${KeyID}`
  );
  return res;
};

export const DeleteCountry = async (KeyID, AdminKeyID) => {
  const res = await getApiWithAuthorization(
    `${UserRoleUrl}/DeleteCountry?AdminKeyID=${AdminKeyID}&CountryKeyID=${KeyID}`
  );
  return res;
};

export const GetCountryLookupList = async () => {
  const res = await getApiWithAuthorization(
    `${UserRoleUrl}/GetCountryLookupList`
  );
  return res;
};
